/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { largerDependencies } from './dependenciesLarger.generated';
import { smallerDependencies } from './dependenciesSmaller.generated';
import { createFibonacciHeapClass } from '../../factoriesAny.js';
export var FibonacciHeapDependencies = {
  largerDependencies: largerDependencies,
  smallerDependencies: smallerDependencies,
  createFibonacciHeapClass: createFibonacciHeapClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesFibonacciHeapClass.generated.js
// module id = 498
// module chunks = 0